<script>
    import Loader from '../../Loader.svelte';
    import SortableTable from '../../SortableTable.svelte';


    import { uuid } from '../../../Database.svelte';
    import { onMount } from 'svelte';
    import {confirm} from '../../Confirmation.svelte';
    import { addFormModal } from '../../../Forms/ModalFormManager.svelte';
    import { forms } from '../../../lib/forms';
    import {notifier} from '@beyonk/svelte-notifications';

    export let assessment_type_model;
    export let section;

    let fields = [
        {
            field: "name",
            label: "Field Name"
        },
        {
            field: "type",
            label: "Field Type"
        },
        {
            field: "required",
            label: "Required"
        }
    ]

    function addField() {
        addFormModal({
            fields: forms['customForm']
        }).then(saveField).catch(() => {});
    }


    function editField(field) {
        addFormModal({
            fields: forms['customForm'],
            data: field
        }).then(saveField).catch(() => {});
    }


    function removeField(field) {
        confirm(`Are you sure you want to remove ${field.name}?`).then(() => {
            section.fields = section.fields.filter(f => f.id != field.id);

            saveSection();
        }).catch(() => {})
    }

    function saveField(field) {
        if (field.id) {
            section.fields = section.fields.map(f => {
                if (f.id == field.id) {
                    return field
                }
                return f
            })
        } else {
            field.id = uuid();
            section.fields = [...section.fields, field];
        }


        saveSection()
    }

    function saveSection() {
        assessment_type_model.saveSection(section).then(() => {
            notifier.success("Form Updated")
        });
    }

    onMount(() => {
        if (!section.fields) {
            section.fields = [];
        }
    })
</script>

<Loader loading={section.fields == undefined}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            Fields
        </h1>

        <SortableTable sortFields={fields} tableData={section.fields} rowKey="id">
            <div slot="rowActions" let:row={field}>
                <button class="button is-info" on:click={() => editField(field)}>Edit</button>
                <button class="button is-danger" on:click={() => removeField(field)}>Delete</button>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addField}>Add Field</button>
                </div>
            </div>
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addField}>Add Field</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>